import ragComponent from "./rag.component";
import showIncidentsOrOrders from "./showIncidentsOrOrders.component";
import { IActionComponentProps } from "./types";
import { QuickActions } from "../quick-actions/quickActions.component";
import showJQL from "./showJQL.component";
import DeprecatedPlaceholder from "./placeholder.depreciated.component";
import NexthinkSmartActions from "./nexthink/smart.actions.component";

const lookupTableAboutChatbotActions: IActionComponentProps = {
    rag: ragComponent,
    "show-incidents": showIncidentsOrOrders,
    "show-orders": showIncidentsOrOrders,
    "jql-query": showJQL,
    "nexthink": DeprecatedPlaceholder,
    "teams": DeprecatedPlaceholder,
    "nexthink-smartsolution": DeprecatedPlaceholder,
    "sustainable-it": DeprecatedPlaceholder,
    "quick-actions": QuickActions,
    default: ragComponent,
    'undefined': ragComponent,
};

export { lookupTableAboutChatbotActions };
